var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass:
        "\n    p0 bg-cl-primary brdr-1 brdr-cl-primary\n    brdr-square h5 cl-tertiary size-selector\n  ",
      class: { active: _vm.isActive },
      attrs: {
        "aria-label": _vm.$t("Select size {variant}", {
          variant: _vm.variant.label
        })
      },
      on: {
        click: function($event) {
          return _vm.$emit("change", _vm.variant)
        }
      }
    },
    [_vm._v("\n  " + _vm._s(_vm.variant.label) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }